"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseViewSchema_1 = require("../baseSchema/baseViewSchema");
class ViewCreateDrippingAlertsSchema extends baseViewSchema_1.BaseViewSchema {
    constructor({ arrivedFrom, alerts }) {
        super({ arrivedFrom });
        this.action = baseSchema_1.ActionsName.VIEW_CREATE_DRIPPING_ALERTS;
        this.alerts = alerts;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action,
            alerts: this.alerts
        };
    }
}
exports.default = ViewCreateDrippingAlertsSchema;
